import React from "react";
import { FiBox, FiCpu, FiEye, FiZap, FiNavigation, FiLayers, FiActivity, FiShield, FiSmartphone, FiShoppingCart, FiCheckCircle } from "react-icons/fi";
import { TbAugmentedReality } from "react-icons/tb";
import {
  LuSettings,
  LuUsers,
  LuCircleCheck,
  LuPalette,
  LuSearch,
  LuSmartphone,
  LuShieldCheck,
  LuPercent,
  LuShield,
  LuCpu,
  LuClipboardList,
  LuCode,
  LuBug,
  LuRocket,
} from "react-icons/lu";

export const arHeroData = {
  backgroundImage: "/images/serviceBanners/ARBanner.webp",
  whiteImage: "/images/serviceBanners/ArW.webp",
  subTitle: " Immersive AR App Experiences",
  title: (
    <>
      Enrich Reality with <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">AR App Development</span> Solutions
    </>
  ),
  description:
    "We develop immersive AR applications that merge digital elements with real world environments to deliver interactive, engaging, and scalable experiences that enhance user engagement and transform modern digital interactions.",
  primaryButton: {
    title: "Get Started",
    onClick: () => console.log("AR Start clicked"),
  },
  secondaryButton: {
    title: "View AR Demos",
    onClick: () => console.log("AR Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Performance",
      desc: "Fast and optimized AR application performance.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive Design",
      desc: "Seamless experience across all devices and screen sizes.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure & Reliable",
      desc: "Built with strong security and stable architecture.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Clean Code",
      desc: "Maintainable and developer-friendly AR development structure.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/reactjs.svg",
      top: "12%",
      right: "10%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(34,211,238,0.35)",
      iconGlow: "rgba(34,211,238,0.9)",
    },
  ],
};

// 2. Stats Block
export const arStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Solutions & Process Block (WhyChooseUs Data)
export const arSolutionsAndProcessData = {
  buildSubtitle: "OUR AR CAPABILITIES",
  buildTitle: "Custom AR App Development Solutions for Every Business Need",
  buildCards: [
    {
      title: "Cross-Platform AR Development",
      desc: "Build AR applications that work seamlessly across Android and iOS devices.",
      icon: TbAugmentedReality,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Enterprise AR Solutions",
      desc: "Develop scalable and secure AR systems for business use cases.",
      icon: FiBox,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce AR Experiences",
      desc: "Create interactive shopping experiences using augmented reality.",
      icon: FiShoppingCart,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand AR Applications",
      desc: "Build real-time AR solutions for service and engagement-based platforms.",
      icon: FiActivity,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "FinTech AR Solutions",
      desc: "Design secure and innovative AR features for financial applications.",
      icon: FiShield,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Custom AR Development",
      desc: "Tailored AR applications built to match specific business requirements.",
      icon: TbAugmentedReality,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OUR DEVELOPMENT PROCESS",
  processTitle: "AR App Development Process",
  processSteps: [
    {
      step: "01",
      title: "Discovery & Consultation",
      description: "Understand business goals, target audience, and AR use case requirements.",
      icon: LuSearch,
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "Define AR features, technology stack, and implementation roadmap.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "Create intuitive and interactive AR experience designs.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Development",
      description: "Build scalable and high-performance AR applications with clean architecture.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Quality Testing",
      description: "Test AR functionality, accuracy, and performance across devices.",
      icon: LuCircleCheck,
    },
    {
      step: "06",
      title: "Deployment & Support",
      description: "Launch AR application and provide continuous updates and maintenance.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE OUR AR APP DEVELOPMENT SERVICES?",
  benefitsTitle: "Why Businesses Choose AR App Development Solutions",
  benefits: [
    "Cross-platform AR compatibility",
    "Faster AR app development",
    "Modern immersive user interface",
    "Smooth AR performance optimization",
    "Efficient development workflow",
    "Scalable AR solutions",
    "Cost-effective AR development",
  ],
  logoImage: "/images/serviceBanners/ARBanner.webp",
  whiteLogoImage: "/images/serviceBanners/ArW.webp",
};

// 4. Portfolio Data
export const arPortfolioData = {
  subtitle: "SUCCESS STORIES",
  title: "AR Experiences Redefining Reality",
  buttonText: "View Case Studies",
  buttonLink: "#",
  apps: [
    {
      title: "DecorView AR",
      badge: "Interior Design",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A virtual furniture placement app with real-time lighting estimation and floor detection.",
      downloads: "Active",
      rating: "5.0",
      image: "https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?auto=format&fit=crop&w=800&q=80",
    },
  ],
};

// 5. Technologies Data
export const arTechnologiesData = {
  techTitle: "AR TOOL STACK",
  technologies: [
    { name: "ARKit / ARCore", icon: "RestAPI" },
    { name: "Unity 3D", icon: "Vite" },
    { name: "Vuforia", icon: "Code" },
    { name: "Three.js", icon: "ReactJS" },
    { name: "Blender", icon: "Palette" },
    { name: "Niantic Lightship", icon: "Provider" },
  ],
  trustTitle: "TRUSTED BY TECH INNOVATORS Worldwide",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle" },
  ],
};

// 6. About Overview
export const arAboutData = [
  {
    title: "AR App Development Company for Interactive Digital Experiences",
    content: (
      <>
        Businesses are increasingly using immersive technologies to improve customer engagement and create more memorable digital interactions. A trusted{" "}
        <b className="text-text-primary font-semibold">ar app development company</b> helps brands blend digital experiences with real-world environments to improve product
        engagement and user interaction. Many businesses struggle to create experiences that feel engaging and innovative in competitive markets. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, AR solutions are developed around business goals and user expectations to help organizations build
        practical and future-focused digital experiences.
      </>
    ),
  },
  {
    title: "Augmented Reality App Development for Better User Engagement",
    content: (
      <>
        Modern users expect interactive experiences that go beyond traditional applications. Reliable{" "}
        <b className="text-text-primary font-semibold">augmented reality app development</b> helps businesses create engaging digital interactions that improve customer
        understanding and product exploration. Companies investing in <b className="text-text-primary font-semibold">ar mobile app development services</b> often improve customer
        engagement because immersive experiences create stronger attention and better interaction quality. Tycho Technologies focuses on practical AR systems designed to support
        usability, business performance, and long-term digital adoption.
      </>
    ),
  },
  {
    title: "Immersive App Development Solutions for Smarter Experiences",
    content: (
      <>
        Interactive technologies are transforming how businesses connect with customers across industries such as retail, healthcare, education, and real estate. Effective{" "}
        <b className="text-text-primary font-semibold">immersive app development solutions</b> help organizations create more meaningful experiences that improve engagement and
        digital interaction quality. Businesses exploring immersive innovation often strengthen technical capabilities through{" "}
        <a href="https://tychotechnologies.com/vr-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          vr app development company
        </a>{" "}
        solutions to create connected virtual experiences that support future-ready digital ecosystems.
      </>
    ),
  },
  {
    title: "Why Businesses Choose an AR Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">ar development company in india</b> continues to grow as businesses seek innovative ways to improve
        customer experiences and digital engagement. Companies investing in <b className="text-text-primary font-semibold">augmented reality services india</b> often prioritize
        better interaction, stronger visualization, and long-term scalability. Businesses partnering with Tycho Technologies benefit from customized AR frameworks designed around
        measurable business objectives and user behavior. Many organizations also integrate{" "}
        <a href="https://tychotechnologies.com/blockchain-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          blockchain development services
        </a>{" "}
        to improve digital trust and support advanced technology ecosystems.
      </>
    ),
  },
];

// 7. FAQs
export const arDevelopmentFaqs = [
  {
    q: "What is AR app development and how can it benefit my business?",
    a: "AR app development overlays digital content onto the real world. It boosts user engagement, improves customer experience, and offers interactive features for retail, education, and real estate.",
  },
  {
    q: "Do your AR apps work on both iOS and Android?",
    a: "Yes. We use ARKit for iOS and ARCore for Android, or cross-platform frameworks like Unity, to ensure maximum device accessibility.",
  },
];
